import { useBlocker } from "react-router-dom";
import { useEffect, useState } from "react";
import { ReactSetStateFunction } from "@utils/utility-types";

interface Props {
  /** Message to show when navigation is blocked */
  alertMessage: string;
}

interface ReturnProps {
  /** Setter for should block navigation */
  setShouldBlockNavigation: ReactSetStateFunction<boolean>;
}

/** A simple hook to block navigation if shouldBlock is true */
export function useBlockNavigation({ alertMessage }: Props): ReturnProps {
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(true);
  const blocker = useBlocker(shouldBlockNavigation);

  // Effect to handle the blocking of navigation
  useEffect(() => {
    if (blocker.state === "blocked") {
      // eslint-disable-next-line no-alert
      const isLeavingConfirmed = globalThis.confirm(alertMessage);

      if (isLeavingConfirmed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, alertMessage]);

  return { setShouldBlockNavigation };
}
